import { type DateIdentifier, toDateTime, } from "@bracket/types";
import { Typography, type Variant, Text, } from "@bracket/ui";
import { DateTime, } from "luxon";
import type { FunctionComponent, } from "react";
import styled from "styled-components";



export declare type DateValueProps = {
	value: DateIdentifier | null;
	variant?: Variant;
	textSize?: SizeVariant;
};



/**
 * A component that displays a formatted date value
 * @param {DateValueProps} props - The component props
 * @param {string} props.value - The ISO date string to format and display
 * @param {Variant} [props.variant="p"] - The typography variant to use for the date text
 * @returns {JSX.Element} A styled date value component
 */
export const DateValue: FunctionComponent<DateValueProps> = ({
	value,
	variant = "p",
}) => {
	const formatted = () => {
		if(value === null) return "-";
		const dt = toDateTime(value);
		return dt.toLocaleString(DateTime.DATETIME_MED);
	}
	return (
		<Brace>
			<Typography variant={variant}>{formatted()}</Typography>
		</Brace>
	);
}


export const DateValueNext = ({
	value,
	textSize,
}: DateValueProps) => {
	const formatted = () => {
		if(value === null) return "-";
		const dt = toDateTime(value);
		return dt.toLocaleString(DateTime.DATETIME_MED);
	}
	return (
		<Text size={textSize}>{formatted()}</Text>
	)
}

const Brace = styled.div`

`
